export const bind = {
    selector: '[data-bind]',
    reactive: true,
    run(el, data, root) {
        const key = el.getAttribute('data-bind');
        el.value = data[key];

        // Prevent duplicate input listeners
        if (!el.__bound) {
            el.addEventListener('input', (e) => {
                data[key] = e.target.value;
            });
            el.__bound = true;
        }

        if (!root.__bindings) root.__bindings = {};
        if (!root.__bindings[key]) root.__bindings[key] = [];

        const alreadyBound = root.__bindings[key].some(fn => fn.__boundTo === el);
        if (!alreadyBound) {
            const callback = (newVal) => {
                el.value = newVal;
            };
            callback.__boundTo = el; // track per element
            root.__bindings[key].push(callback);
        }
    }
};
